import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { handleErrorMessage, checkFileFormat } from '../../utils';
import ButtonSave from '../Reusable/ButtonSave';
import withTranslations from '../../utils/HighOrderComponent';
import UploadFormTable from '../Reusable/UploadFormTable';
import { uploadFileMaxSize } from '../../constants/globals';

class ModalForUploadSignetExample extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedDocument: [],
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onFileChange = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };

  handleDeleteDocument = (documentName) => {
    let uploadedDocumentsNames = [];
    let uploadedDocumentsAsArray = Array.from(this.state.uploadedDocument);

    for (let i = 0; i < this.state.uploadedDocument.length; i++) {
      uploadedDocumentsNames.push(this.state.uploadedDocument[i].name);
    }

    var index = uploadedDocumentsNames.indexOf(documentName);
    uploadedDocumentsAsArray.splice(index, 1);
    this.setState({
      uploadedDocument: uploadedDocumentsAsArray,
    });
  };

  handleClientValidation = () => {
    let hasError = false;
    const { Errors } = this.props.t;
    let errors = {};

    if (this.state.uploadedDocument.length === 0) {
      errors['uploadedDocument'] = Errors.imageNotUploaded;
      hasError = true;
    }

    if (this.state.uploadedDocument) {
      if (checkFileFormat(this.state.uploadedDocument)) {
        errors['uploadedDocument'] = Errors.invalidFormat;
        hasError = true;
      }
    }

    if (this.state.uploadedDocument.length > 0) {
      let uploadedDataSize = 0;
      for (let i = 0; i < this.state.uploadedDocument.length; i++) {
        uploadedDataSize += this.state.uploadedDocument[i].size;
      }
      if (uploadedDataSize >= uploadFileMaxSize) {
        errors['uploadedDocument'] = Errors.invalidFileSize;
        hasError = true;
      }
    }

    this.setState({ errors });

    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    let formData = new FormData();
    formData.append('file', this.state.uploadedDocument[0]);
    this.props.handleUpload(formData);
  };

  render() {
    const { error, t } = this.props || {},
      { Labels } = t || {};

    const { errors } = this.state;

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title mb-5">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row mt-3 mb-4">
                <UploadFormTable
                  name="uploadedDocument"
                  onChange={this.onFileChange}
                  handleDeleteDocument={this.handleDeleteDocument}
                  uploadedFiles={this.state.uploadedDocument}
                  placeholder={t.Placeholders.uploadSignetDestroyed}
                  errors={handleErrorMessage(
                    error,
                    'uploadedDocument',
                    errors.uploadedDocument
                  )}
                />
              </div>
              <div className="form-row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForUploadSignetExample,
  'ModalForUploadSignetExample'
);
